import { Injectable } from '@angular/core';
import {
  Arrow,
  ArrowType,
  IEdge,
  IGraph,
  INode,
  PolylineEdgeStyle,
} from '@yfiles/yfiles';
import { ProcessConnection, ProcessEdgeTag } from '../models/business-process.model';
import { ProcessPortConfiguration } from './business-process-port.service';
import { BusinessProcessLabelService } from './business-process-label.service';
@Injectable({ providedIn: 'root' })
export class BusinessProcessEdgeService {
  constructor(private readonly labels: BusinessProcessLabelService) {}
  createEdgeStyle() {
    return new PolylineEdgeStyle({
      stroke: '1.5px #64748B',
      targetArrow: new Arrow({
        type: ArrowType.TRIANGLE,
        fill: '#64748B',
        stroke: '#64748B',
      }),
    });
  }
  createEdges(
    g: IGraph,
    cs: readonly ProcessConnection[],
    ports: ProcessPortConfiguration,
    order: ReadonlyMap<INode, number>,
  ): IEdge[] {
    const out = this.group(cs, true),
      inc = this.group(cs, false),
      key = (c: ProcessConnection) =>
        order.get(c.target) ?? order.get(c.source) ?? Number.MAX_SAFE_INTEGER;
    for (const l of [...out.values(), ...inc.values()])
      l.sort((a, b) => key(a) - key(b));
    return cs.map((c) => {
      const si = out.get(c.source)!.indexOf(c),
        ti = inc.get(c.target)!.indexOf(c),
        sp = ports.outputPorts.get(c.source)?.[si],
        tp = ports.inputPorts.get(c.target)?.[ti];
      if (!sp || !tp)
        throw new Error('Unable to match process connection to a port.');
      const e = g.createEdge(sp, tp);
      e.tag = { edge: c.edge, connection: c } satisfies ProcessEdgeTag;
      if (c.label) this.labels.addEdgeLabel(g, e, c.label);
      return e;
    });
  }
  private group(cs: readonly ProcessConnection[], source: boolean) {
    const m = new Map<INode, ProcessConnection[]>();
    for (const c of cs) {
      const n = source ? c.source : c.target;
      if (!m.has(n)) m.set(n, []);
      m.get(n)!.push(c);
    }
    return m;
  }
}
